import { useConfigQuery } from "@hooks";

import * as Apis from "../api";

const useCostCenterQuery = (() => {
  return useConfigQuery({ apis: Apis });
})();

export default useCostCenterQuery;
